import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	requiredFieldsUnsupportedForAdmin: {
		id: 'issue-create.modal.create-form.section-messages.required-fields-unsupported-for-admin',
		defaultMessage:
			"Field(s) marked with <button></button> aren't supported. To continue creating issues, make the field(s) optional and remove the field(s) from this screen.",
		description: 'Error message for admin when required fields are not supported',
	},
	requiredFieldsUnsupportedForUser: {
		id: 'issue-create.modal.create-form.section-messages.required-fields-unsupported-for-user',
		defaultMessage:
			"Field(s) marked with <button></button> aren't supported. To continue creating issues, <a>reach out to your Jira admin</a> to make the field(s) optional and remove the field(s) from this screen.",
		description: 'Error message for user when required fields are not supported',
	},
	requiredFieldsUnsupportedForAdminIssueTermRefresh: {
		id: 'issue-create.modal.create-form.section-messages.required-fields-unsupported-for-admin-issue-term-refresh',
		defaultMessage:
			"Field(s) marked with <button></button> aren't supported. To continue creating work items, make the field(s) optional and remove the field(s) from this screen.",
		description: 'Error message for admin when required fields are not supported',
	},
	requiredFieldsUnsupportedForUserIssueTermRefresh: {
		id: 'issue-create.modal.create-form.section-messages.required-fields-unsupported-for-user-issue-term-refresh',
		defaultMessage:
			"Field(s) marked with <button></button> aren't supported. To continue creating work items, <a>reach out to your admin</a> to make the field(s) optional and remove the field(s) from this screen.",
		description: 'Error message for user when required fields are not supported',
	},
});
